import services from './services.js';
import NProgress from 'nprogress';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import viewPhoto from 'src/common/js/viewPhoto';
import $http from '$http';



export default {
    mixins: [services],
    components: {

    },
    props: {
        value: {}
    },
    data() {
        return {
            dialogVisible: false,
            isReadOnly: false,
            OrderData: {},
            IsShow: false,
            PictureVisible: false,
            dialogImageUrl: '',
            status: [{
                "name": "审核通过",
                "id": "6"
            }, {
                "name": "审核不通过",
                "id": "11"
            }],
            auditFormData: this.getAuditFormData(),
            isShowAuditRemark: false, //审核意见
            isShowKingdeeCode: false, //金蝶编码
            title: '',
            TotalMoney: 0
        }
    },
    computed: {},
    methods: {
        dialogClose() {
            this.dialogVisible = false;
            this.isReadOnly = false;
            this.isShowAuditRemark = false;
            this.isShowKingdeeCode = false;
        },
        // 审核提交需要的数据
        getAuditFormData() {
            return cloneDeep({
                OrderId: 0,
                AuditRemark: "",
                OrderStatus: '',
                KingdeeAgentCode: ""
            });
        },
        getErpConfig() {
            return cloneDeep({
                id: ""
            });
        },
        //判断审核状态联动金蝶编码（审核通过显示）和审核意见（审核不通过显示）
        chooseType(val) {
            //console.log(val)
            //6 显示金蝶编码
            if (val == 6) {
                this.isShowKingdeeCode = true;
                this.isShowAuditRemark = false;
                this.auditFormData.AuditRemark = '';
            } else if (val == 11) {
                //11 显示审核意见
                this.isShowAuditRemark = true;
                this.isShowKingdeeCode = false;
                this.auditFormData.KingdeeAgentCode = '';
            } else {
                this.isShowAuditRemark = false;
                this.isShowKingdeeCode = false;
            }
        },
        show(options) {
            //console.log(options)
            this.isReadOnly = options.isReadOnly;
            if (this.isReadOnly) {
                this.title = "合同款查看"
            } else {
                this.title = "合同款审核"
            }
            let opts = $.extend({}, this.getErpConfig(), options);
            this.dialogVisible = true;
            this.auditFormData = this.getAuditFormData();
            this.getInfo(opts);
        },
        LookPicture(Url) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: Url,
                    id: ""
                }]
            });
        },
        submit() {
            //必填判断
            var flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "审核状态",
                    value: this.auditFormData.OrderStatus,
                    required: true
                }, {
                    name: "审核意见",
                    value: this.auditFormData.AuditRemark,
                    required: this.isShowAuditRemark
                }]
            });
            // if (this.isShowKingdeeCode) {
            //     var flag2 = util.checkForm({
            //         ele: this,
            //         rules: [{
            //             name: "金蝶编码",
            //             value: this.auditFormData.KingdeeAgentCode,
            //             required: true
            //         }]
            //     });
            // } else if (this.isShowAuditRemark) {
            //     var flag2 = util.checkForm({
            //         ele: this,
            //         rules: [{
            //             name: "审核意见",
            //             value: this.auditFormData.AuditRemark,
            //             required: true
            //         }]
            //     });
            // }
            if (!flag) {
                return;
            }
            console.log(this.auditFormData)
            this.auditConfirm(this.auditFormData)
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/voucherAudit/components/paymentAuditOrder/vm.js